// extracted by mini-css-extract-plugin
module.exports = {"height":"card_height_2bDtJ","layout":"card_layout_2BdFH"};